import React, { Fragment, FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { localize } from "src/l10n";

interface IUberReviewNotification {
    notification: {
        // Generic UberReview payload (post-rename: see UberReviewNotificationProjection).
        target?: {
            displayName?: string;
            url?: string;
            uberType?: number;
        };
        reviewId?: number;
        userName?: string;
        comment?: string;
        status?: string;
        // SpintrAPI base fields:
        url?: string;
        objectId?: number;
    };
}

const targetHref = (n: IUberReviewNotification["notification"]) =>
    n.target?.url ?? n.url ?? (n.objectId ? `/goto/${n.objectId}` : "#");

const targetName = (n: IUberReviewNotification["notification"]) =>
    n.target?.displayName ?? "";

export const StudioAppSubmittedForReviewNotification: FunctionComponent<IUberReviewNotification> = ({ notification }) => {
    if (!notification) return null;
    return (
        <Fragment>
            {notification.userName ? notification.userName + " " : ""}
            {localize("STUDIO_NOTIFICATION_SUBMITTED_FOR_REVIEW")} {" "}
            <Link to={targetHref(notification)}>{targetName(notification)}</Link>
            {"."}
        </Fragment>
    );
};

export const StudioAppReviewApprovedNotification: FunctionComponent<IUberReviewNotification> = ({ notification }) => {
    if (!notification) return null;
    return (
        <Fragment>
            <Link to={targetHref(notification)}>{targetName(notification)}</Link>
            {" " + localize("STUDIO_NOTIFICATION_APPROVED")}
            {notification.comment && (
                <> {localize("MedMeddelandet")}: "{notification.comment}"</>
            )}
            {"."}
        </Fragment>
    );
};

export const StudioAppReviewChangesRequestedNotification: FunctionComponent<IUberReviewNotification> = ({ notification }) => {
    if (!notification) return null;
    return (
        <Fragment>
            <Link to={targetHref(notification)}>{targetName(notification)}</Link>
            {" " + localize("STUDIO_NOTIFICATION_CHANGES_REQUESTED")}
            {notification.comment && (
                <> {localize("MedMeddelandet")}: "{notification.comment}"</>
            )}
            {"."}
        </Fragment>
    );
};

export const StudioAppReviewRejectedNotification: FunctionComponent<IUberReviewNotification> = ({ notification }) => {
    if (!notification) return null;
    return (
        <Fragment>
            <Link to={targetHref(notification)}>{targetName(notification)}</Link>
            {" " + localize("STUDIO_NOTIFICATION_REJECTED")}
            {notification.comment && (
                <> {localize("MedMeddelandet")}: "{notification.comment}"</>
            )}
            {"."}
        </Fragment>
    );
};

export const StudioAppReviewCommentNotification: FunctionComponent<IUberReviewNotification> = ({ notification }) => {
    if (!notification) return null;
    return (
        <Fragment>
            {notification.userName ? notification.userName + " " : ""}
            {localize("STUDIO_NOTIFICATION_NEW_COMMENT")} {" "}
            <Link to={targetHref(notification)}>{targetName(notification)}</Link>
            {notification.comment && (
                <>: "{notification.comment}"</>
            )}
            {"."}
        </Fragment>
    );
};
